
import { noop } from 'lodash';

import { Dropdown, DropdownItem } from '@uikit';

import { AngleDown } from '@uikit/icons/AngleDown';

interface DropdownSelectProps<Value extends string | number> {
  options: {
    value: Value;
    label: string;
  }[];
  value: Value;
  onValueChange?: (value: Value) => void;
}

const DropdownSelect = <Value extends string | number>({
  options,
  value,
  onValueChange = noop,
}: DropdownSelectProps<Value>) => {
  return (
    <Dropdown
      trigger={
        <button className="flex items-center justify-start focus-visible:outline-none">
          {options.find((option) => option.value === value)?.label}
          <AngleDown className="icon text-secondary" />
        </button>
      }
    >
      {options.map((option) => {
        return (
          <DropdownItem
            key={option.value}
            onClick={() => onValueChange(option.value)}
            label={option.label}
          />
        );
      })}
    </Dropdown>
  );
};

export default DropdownSelect;
